import { useState } from "react";
import { DurationInputSelectProps } from "./duration-input-select";

export interface ViewProps {
    show: boolean;
    changeShow: any;
    value: string | undefined;
    onChange: (v: string) => void;
    clear: () => void;
}

export const useDurationInputSelect = (props: DurationInputSelectProps): ViewProps => {
    const [show, changeShow] = useState<boolean>(false);
    const [value, setValue] = useState<string | undefined>(props.value);

    const onChange = (v: string | undefined) => {
        if (props.onChange) {
            props.onChange(v);
        }
        setValue(v);
        changeShow(false);
    }

    const clear = () => {
        onChange(undefined);
    }

    return {
        show,
        changeShow,
        onChange,
        clear,
        value
    };
}
